export const p1 = {
  id: 5,
  title: "„Debiut Naukowy” 2021",
  subtitle: "",
  details: {
    title:
      "“URBAN PLANNING OF RESIDENTIAL AREAS FOR MAMMALS BIODIVERSITY AS DETERMINED BY RESIDENTS’ PERSPECTIVE: CASE STUDY OF JANOW AND JULIANOW, LODZ”",
    date: "11.2021",
    "co-authors": "Aleksandra Drążczyk",
    type: "scientific monograph",
  },
  split: {
    imgBig: "publi/Publication-1.jpg",
    imgSm: "publi/Publication-2.jpg",

    desc: [
      "The study was conducted by a pair of architecture and sociology students. Its main goal was to analyze the relationship between residential buildings and the coexistence of residents with fauna.",
      'The article based on the study was written in English and submitted to the competition for students "Sustainable development - Scientific debut 2021". It has been released in November 2021 as a part of a research monograph.',
      "The article presents the most important results of the research on the biodiversity of mammals in suburban areas from the perspective of the inhabitants of the Łódź housing estates: Janów and Julianów. We have found that wild mammals are present in the indicated areas and the meetings between them and the inhabitants occur. Simultaneously, the buildings do not create the best conditions for their migration. It is important to plan buildings based on the knowledge of the animal migration paths and educate the inhabitants, so they will be able to behave in a way that is safe for themselves and the animals.",
    ],
  },
};
export const p2 = {
  id: 5,
  title: "Biodiversity in design",
  subtitle: "",
  details: {
    title: "10 Ways to Increase Biodiversity in Any Design",
    date: "08.2021",
    "co-authors": "Jolma Architects",
    type: "online article on the UK landscape architects website",
  },

  desc: [
    "The article was a short and easy-to-read, yet in-depth analysis of the literature on biodiversity in design. I wrote it in English during my internship in Finland with the support of landscape architect Ashley D. Penn.",
    "Please use the link below to open the article:",
    "<a href='https://land8.com/10-ways-to-increase-biodiversity-in-any-design' target='blank'>10 ways to increase biodiversity in any design</a>",
    "<a href='https://land8.com/is-biodiversity-in-cities-important/' target='blank'>Is Biodiversity in Cities Important?</a>",
  ],
};
